@if (connectivity.hasError()) {
  <div class="error-banner" role="alert">
    <app-icon name="x" [size]="16" />
    <span>{{ 'shared.connectivityError' | translate }}</span>
    <div class="actions">
      <button type="button" (click)="reload()">{{ 'shared.reload' | translate }}</button>
      <button type="button" class="dismiss" (click)="connectivity.dismiss()">
        {{ 'shared.dismiss' | translate }}
      </button>
    </div>
  </div>
}
